import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeModal } from 'src/modules/shared/modal/actions';

const Modal = dynamic(() => import('./modal'), { ssr: false });
const AssignBadgesModal = dynamic(() => import('./assignBadgesModal'), { ssr: false });
const ConfirmModal = dynamic(() => import('./confirmModal'), { ssr: false });
const DFPModal = dynamic(() => import('src/modules/shared/modal/components/dfpModal'), { ssr: false });
const EmailConfirmationModal = dynamic(() => import('./emailConfirmationModal'), { ssr: false });
const ExistingLoginSocialModal = dynamic(() => import('./signup/existingLoginSocialModal'), { ssr: false });
const FilterOptionsModal = dynamic(() => import('src/modules/search/posts/components/filterOptionsModal'), { ssr: false });
const HuLocalSignupModal = dynamic(() => import('./signup/huLocalSignupModal'), { ssr: false });
const LoginModal = dynamic(() => import('./login/loginModal'), { ssr: false });
const PrivacyTipsModal = dynamic(() => import('src/modules/shared/modal/components/privacyTipsModal'), { ssr: false });
const SearchFeedbackModal = dynamic(() => import('src/modules/shared/feedback/searchFeedbackModal'), { ssr: false });
const SearchSortByModal = dynamic(() => import('src/modules/community/communitySearch/components/sortByModal'), { ssr: false });
const SentimentFeedbackModal = dynamic(() => import('src/modules/shared/feedback/sentimentFeedbackModal'), { ssr: false });
const SignupModal = dynamic(() => import('./signup/signupModal'), { ssr: false });
const SignupSocialModal = dynamic(() => import('./signup/signupSocialModal'), { ssr: false });
const SignupSurvey = dynamic(() => import('./signup/signupSurvey'), { ssr: false });
const SimilarToMeTipsModal = dynamic(() => import('src/modules/shared/modal/components/similarToMeTipsModal'), { ssr: false });
const TagFilterOptionsModal = dynamic(() => import('src/pages/tag/tagFilterOptionsModal'), { ssr: false });

const MODAL_COMPONENTS = {
  'DEFAULT': Modal,
  'ASSIGN_BADGES': AssignBadgesModal,
  'CONFIRM': ConfirmModal,
  'DFP': DFPModal,
  'EMAIL_CONFIRMATION': EmailConfirmationModal,
  'EXISTING_LOGIN_SOCIAL': ExistingLoginSocialModal,
  'HULOCAL_SIGN_UP': HuLocalSignupModal,
  'LOGIN': LoginModal,
  'PRIVACY_TIPS': PrivacyTipsModal,
  'SEARCH_FEEDBACK': SearchFeedbackModal,
  'SEARCH_FILTER_OPTIONS': FilterOptionsModal,
  'SEARCH_SORT_BY': SearchSortByModal,
  'SENTIMENT_FEEDBACK': SentimentFeedbackModal,
  'SIGN_UP_SOCIAL': SignupSocialModal,
  'SIGN_UP_SURVEY': SignupSurvey,
  'SIGN_UP': SignupModal,
  'SIMILAR_TO_ME_TIPS': SimilarToMeTipsModal,
  'TAG_FILTER_OPTIONS': TagFilterOptionsModal,
};

const ModalRoot = ({ modalType, modalProps, closeModal }) => {
  if (!modalType) return null;

  const SpecificModal = MODAL_COMPONENTS[modalType];
  if (!SpecificModal) return null;

  return <SpecificModal {...modalProps} closeModal={closeModal} />;
};

ModalRoot.propTypes = {
  closeModal: PropTypes.func,
  modalProps: PropTypes.object,
  modalType: PropTypes.string,
};

ModalRoot.defaultProps = {
  closeModal: () => {},
  modalType: null,
  modalProps: {},
};

const mapStateToProps = state => state.modal;

export default connect(mapStateToProps, { closeModal })(ModalRoot);
